import { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Play } from "lucide-react";

export default function VideosPage() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetch(
      "https://pranaam.pranaamhospitals.in/wp-json/wp/v2/videos?_embed&per_page=100"
    )
      .then((res) => res.json())
      .then((data) => {
        const formatted = data.map((item) => ({
          title: item.title?.rendered,
          doctor: item.acf?.doctor_name || "Pranaam Hospitals",
          video_url: item.acf?.video_url,
          thumbnail:
            item.acf?.thumbnail?.url ||
            item._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
            "/placeholder.svg",
        }));

        setVideos(formatted);
      })
      .catch((err) => console.error("FETCH ERROR:", err));
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#951C25] to-black py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Health Education Videos
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Expert medical advice and health tips from our experienced doctors
              and specialists
            </p>
          </div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {videos.map((video, index) => (
                <Card
                  key={index}
                  className="group cursor-pointer border-none shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden"
                  onClick={() => window.open(video.video_url, "_blank")}
                >
                  <CardContent className="p-0">
                    <div className="relative h-48 overflow-hidden bg-gray-100">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />

                      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors flex items-center justify-center">
                        <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                          <Play
                            className="w-8 h-8 text-[#951C25] ml-1"
                            fill="currentColor"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="p-4">
                      <h3 className="font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-[#951C25] transition-colors">
                        {video.title}
                      </h3>

                      <p className="text-sm text-gray-600">
                        {video.doctor}
                      </p>

                      <div className="mt-3 pt-3 border-t border-gray-100">
                        <span className="text-xs font-medium text-[#951C25]">
                          Pranaam Hospitals
                        </span>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <Card className="max-w-4xl mx-auto border-none shadow-xl bg-gradient-to-r from-[#951C25] to-black overflow-hidden">
            <CardContent className="p-12 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Subscribe for More Health Tips
              </h2>

              <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
                Stay updated with the latest health education videos from our
                expert doctors
              </p>

              <button className="px-8 py-3 bg-white text-[#951C25] font-semibold rounded-lg hover:bg-gray-100 transition-colors">
                Subscribe Now
              </button>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}
